import "./ECLSwitch.css";
import React from "react";

/**
 * ECLSwitch renders a switch element that can be toggled on or off.
 *
 * @export
 * @param {Object} props
 *    -playwrightId - [string] - required - provide an ID to allow for lookup of the value of the element
 *    -toggle - [bool] - required - Used to set the initial value of the switch.
 *    -handleToggle - [function] - required - A function to handle any changes to the switch element.
 *    (e.g. toggle-on / toggle-off)
 * @returns {ReactComponent}
 */

export default function ECLSwitch({ toggle, handleToggle, playwrightId }) {
   return (
      <label className={`switch ${toggle && "active"}`}>
         <input type="checkbox" checked={toggle} onChange={handleToggle} />
         <span data-testid={playwrightId} className="slider round"></span>
      </label>
   );
}
